import { render, staticRenderFns } from "./ArcanitePartner.vue?vue&type=template&id=4bacf52c&scoped=true"
import script from "./ArcanitePartner.vue?vue&type=script&lang=js"
export * from "./ArcanitePartner.vue?vue&type=script&lang=js"
import style0 from "./ArcanitePartner.vue?vue&type=style&index=0&id=4bacf52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bacf52c",
  null
  
)

export default component.exports